var map = {
	"./zizhi1.jpg": "b6cf",
	"./zizhi10.jpg": "da69",
	"./zizhi11.jpg": "c2ed",
	"./zizhi12.jpg": "242a",
	"./zizhi2.jpg": "591c",
	"./zizhi3.jpg": "a761",
	"./zizhi4.jpg": "685c",
	"./zizhi5.jpg": "6e65",
	"./zizhi6.jpg": "ed3f",
	"./zizhi7.jpg": "75a9",
	"./zizhi8.jpg": "b473",
	"./zizhi9.jpg": "9972"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5287";